import { render, staticRenderFns } from "./WishingWellList.vue?vue&type=template&id=6cb49400&scoped=true"
import script from "./WishingWellList.vue?vue&type=script&lang=js"
export * from "./WishingWellList.vue?vue&type=script&lang=js"
import style0 from "./WishingWellList.vue?vue&type=style&index=0&id=6cb49400&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb49400",
  null
  
)

export default component.exports